import InsertEdgeBase from './InsertEdgeBase';
import { EdgeProps, getBezierPath } from '@xyflow/react';

export default function InsertEdge(props: EdgeProps) {
  return <InsertEdgeBase {...props} getPath={getBezierPath} />;
}
